import React from 'react';
import PropTypes from 'prop-types';
import './Chip.scss';

const Chip = ({ label, onClose, className, iconClassName, style, textStyle, closeAriaLabel }) => (
  <div className={`${className || ''} chip`} style={style}>
    <div className={`chip-text`} style={textStyle}>{label}</div>
    {onClose ? (
      <i
        className={`lf-icon lf-icon-close-round chip-close ${iconClassName || ''}`}
        role="button"
        aria-label={closeAriaLabel || 'close'}
        onClick={e => {
          e.stopPropagation();
          onClose(e);
        }}
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            e.stopPropagation();
            onClose(e);
          }
        }}
      />
    ) : null}
  </div>
);

Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  style: PropTypes.object,
  textStyle: PropTypes.object,
  closeAriaLabel: PropTypes.string
};

Chip.defaultProps = {
  onClose: null,
  className: '',
  iconClassName: '',
  style: {},
  textStyle: {},
  closeAriaLabel: 'close'
};

export default Chip;

